import { PayloadAction } from '@reduxjs/toolkit';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

interface RemoveImageDocumentFromDictPayload {
  documentId: number;
}

export const removeImageDocumentFromDictAction = (state: ImageHandlingState, action: PayloadAction<RemoveImageDocumentFromDictPayload>) => {
  const { documentId } = action.payload;

  // Remove document ID from all contexts
  Object.values(state.imagesDocumentsContexts).forEach((context) => {
    context.documentIds = context.documentIds.filter((id) => id !== documentId);
  });

  // Remove document from the dictionary
  delete state.imagesDocumentsDict[documentId];
};
